module.exports = __webpack_public_path__ + "media/svg-new/geography-1bdd1d7b.svg";